import { BaseFormProps, FormOpenMode } from './types';
import {
    Container, Content, FormContainer, StyledUniversalForm,
} from './styled';
import FormFooter from './footer';
import Fields from './fields';

interface FormProps extends BaseFormProps {
    mode?: FormOpenMode;
    phoneTypes?: string[];
}

const CreateEditPhoneNumberForm = ({
    mode = 'create',
    onRequestClose = () => {},
    phoneTypes = [],
    ...formProps
}: FormProps) => (
    <Container>
        <Content>
            <FormContainer>
                <StyledUniversalForm
                    id="customer-phone-number-form"
                    {...formProps}
                >
                    <Fields phoneTypes={phoneTypes} />
                </StyledUniversalForm>
            </FormContainer>
        </Content>
        <FormFooter
            formId="customer-phone-number-form"
            submitButtonLabel={mode === 'edit' ? 'Update' : 'Add'}
            onCancelClick={onRequestClose}
        />
    </Container>
);

export default CreateEditPhoneNumberForm;
